<template>
  <page-main @back="() => (isShowLeave = true)">
    <template slot="nav">
      <div class="score-nav">
        <p>五环评分</p>
      </div>
    </template>
    <template slot="main">
      <div class="page-main">
        <div class="step-box">
          <el-steps
            :active="activeStep"
            finish-status="success"
            process-status="wait"
            simple
          >
            <el-step title="比赛信息"></el-step>
            <el-step title="球探信息"></el-step>
            <el-step title="球员信息"></el-step>
            <el-step title="五环评分"></el-step>
            <el-step title="主观评价"></el-step>
          </el-steps>
        </div>
        <div class="scroll-area">
          <template>
            <vue-scroll :ops="ops">
              <div class="scroll-wrapper scout-rate form-content">
                <el-form
                  :inline="false"
                  ref="fiveRings"
                  :model="fiveRings"
                  label-width="220px"
                >
                  <div class="tr">
                    <div class="td w240 content-center">
                      <span class="thead">评分项</span>
                    </div>
                    <div class="td content-center">
                      <span class="thead">评分指标</span>
                    </div>
                  </div>

                  <div class="tr">
                    <div class="td w240 content-center">
                      <span>技术</span>
                    </div>
                    <div class="td">
                      <div
                        class="conten-wrapper sub-tr"
                        v-for="item in fiveRings.formTechnicalList"
                        :key="item.uuid"
                      >
                        <div class="sub-td" :title="item.indicator_paraphrase">
                          {{ item.indicator_name }}
                        </div>
                        <div class="sub-td">
                          <el-rate
                            show-score
                            score-template="{value}分"
                            v-model="item.score"
                          ></el-rate>
                          <p class="score-tips" :class="item.score | scoreStyle">
                            {{ item.score | scoreFilter }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 战术 -->
                  <div class="tr">
                    <div class="td w240 content-center">
                      <span>战术</span>
                    </div>
                    <div class="td">
                      <div
                        class="conten-wrapper sub-tr"
                        v-for="item in fiveRings.formTacticalList"
                        :key="item.uuid"
                      >
                        <div class="sub-td" :title="item.indicator_paraphrase">
                          {{ item.indicator_name }}
                        </div>
                        <div class="sub-td">
                          <el-rate
                            show-score
                            score-template="{value}分"
                            v-model="item.score"
                          ></el-rate>
                          <p class="score-tips" :class="item.score | scoreStyle">
                            {{ item.score | scoreFilter }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 身体 -->
                  <div class="tr">
                    <div class="td w240 content-center">
                      <span>身体</span>
                    </div>
                    <div class="td">
                      <div
                        class="conten-wrapper sub-tr"
                        v-for="item in fiveRings.formPhysicalList"
                        :key="item.uuid"
                      >
                        <div class="sub-td" :title="item.indicator_paraphrase">
                          {{ item.indicator_name }}
                        </div>
                        <div class="sub-td">
                          <el-rate
                            show-score
                            score-template="{value}分"
                            v-model="item.score"
                          ></el-rate>
                          <p class="score-tips" :class="item.score | scoreStyle">
                            {{ item.score | scoreFilter }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 心智 -->
                  <div class="tr">
                    <div class="td w240 content-center">
                      <span>心智</span>
                    </div>
                    <div class="td">
                      <div
                        class="conten-wrapper sub-tr"
                        v-for="item in fiveRings.formMentalList"
                        :key="item.uuid"
                      >
                        <div class="sub-td" :title="item.indicator_paraphrase">
                          {{ item.indicator_name }}
                        </div>
                        <div class="sub-td">
                          <el-rate
                            show-score
                            score-template="{value}分"
                            v-model="item.score"
                          ></el-rate>
                          <p class="score-tips" :class="item.score | scoreStyle">
                            {{ item.score | scoreFilter }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 社交 -->
                  <div class="tr">
                    <div class="td w240 content-center">
                      <span>社交</span>
                    </div>
                    <div class="td">
                      <div
                        class="conten-wrapper sub-tr"
                        v-for="item in fiveRings.formSociMalList"
                        :key="item.uuid"
                      >
                        <div class="sub-td" :title="item.indicator_paraphrase">
                          {{ item.indicator_name }}
                        </div>
                        <div class="sub-td">
                          <el-rate
                            show-score
                            score-template="{value}分"
                            v-model="item.score"
                          ></el-rate>
                          <p class="score-tips" :class="item.score | scoreStyle">
                            {{ item.score | scoreFilter }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form>
              </div>
            </vue-scroll>
          </template>
        </div>
        <div class="btn-box">
          <el-button type="danger" class="mr-25" @click="tempSave">
            暂时保存</el-button
          >
          <el-button type="danger" class="mr-25" @click.native.prevent="goBack"
            >上一步</el-button
          >
          <el-button
            type="primary"
            @click.native.prevent="handleClick('completeFormDom')"
            >下一步</el-button
          >
          <yioks-tips
            :showTips="isShowLeave"
            tips="离开页面未提交数据将会丢失，确认离开？"
            @hideTips="handleLeave"
          ></yioks-tips>
        </div>
      </div>
    </template>
  </page-main>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import yioksStorage from "@/assets/js/yioksStorage";
import {
  getFiveRingsInfo,
  getReportIndicatorsInfo,
  postFiveRingsReport,
} from "@/api/scout";
import { scoreFilter } from '@/assets/js/yioksFilters';

export default {
  data() {
    return {
      isShowLeave: false,
      ops: ops(),
      activeStep: 4,
      technicalList: [], //技术列表
      tacticalList: [], //战术列表
      physicalList: [], // 身体列表
      mentalList: [], // 心智列表
      socialList: [], // 社交列表
      fiveRings: {
        formTechnicalList: [], //技术列表
        formTacticalList: [], //战术列表
        formPhysicalList: [], // 身体列表
        formMentalList: [], // 心智列表
        formSociMalList: [], // 社交列表
      },
    };
  },

  computed: {
    playerId() {
      const { playerId } = this.$route.query;
      return playerId;
    },
    reportId() {
      const { reportId } = this.$route.query;
      return reportId;
    },
    isEdit() {
      const { isEdit } = this.$route.query;
      return 1 === Number(isEdit);
    },
    scoutId() {
      const { scoutId } = this.$route.query;
      const localScoutId = yioksStorage.getItem("scoutId");
      return scoutId || localScoutId;
    },
  },

  components: {
    "page-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
  },

  filters: {
   scoreFilter,
   // 成绩颜色提示
    scoreStyle(val) {
      let cb = '';
      if(+val === 0) cb = 'default'
      if(+val === 1 || +val === 2) cb = 'err'
      if(+val === 3 || +val === 4) cb = 'warn'
      if(+val === 5) cb = 'suc'
      return cb;
    }
  },

  mounted() {
    if (this.isEdit) {
      this.loadEditFiveRingsInfo();
    } else {
      this.loadIndicators(); // 加载评分指标项
    }
  },

  methods: {
    goBack() {
      const {
        formTechnicalList,
        formTacticalList,
        formPhysicalList,
        formMentalList,
        formSociMalList,
      } = this.fiveRings;
      const tem_technical = this.parseFormData(formTechnicalList);
      const tem_tactical = this.parseFormData(formTacticalList);
      const tem_physical = this.parseFormData(formPhysicalList);
      const tem_mental = this.parseFormData(formMentalList);
      const tem_social = this.parseFormData(formSociMalList);
      const submitData = {
        id: this.reportId,
        scoreList: JSON.stringify([
          ...tem_technical,
          ...tem_tactical,
          ...tem_physical,
          ...tem_mental,
          ...tem_social,
        ]),
      };
      postFiveRingsReport(submitData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.$router.push({
            path: "player_info",
            query: {
              ...this.$route.query,
              playerId: this.playerId,
              reportId: this.reportId,
              isEdit: 1,
            },
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 点击 下一步
    handleClick() {
      const {
        formTechnicalList,
        formTacticalList,
        formPhysicalList,
        formMentalList,
        formSociMalList,
      } = this.fiveRings;
      const tem_technical = this.parseFormData(formTechnicalList);
      const tem_tactical = this.parseFormData(formTacticalList);
      const tem_physical = this.parseFormData(formPhysicalList);
      const tem_mental = this.parseFormData(formMentalList);
      const tem_social = this.parseFormData(formSociMalList);
      const submitData = {
        id: this.reportId,
        scoreList: JSON.stringify([
          ...tem_technical,
          ...tem_tactical,
          ...tem_physical,
          ...tem_mental,
          ...tem_social,
        ]),
      };
      postFiveRingsReport(submitData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          let routeQuery = {
            scoutId: this.scoutId,
            reportId: this.reportId,
            isEdit: 1,
          };
          if (this.isEdit) {
            routeQuery["isEdit"] = 1;
          }
          this.$router.push({
            path: "subjective",
            query: routeQuery,
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 离开
    handleLeave(status, flag) {
      if (flag) {
        const scoutName = this.scoutName;
        this.$router.push({
          path: "list",
          query: {
            scoutName,
          },
        });
      }
      this.isShowLeave = false;
    },

    // 暂时保存
    tempSave() {
      const {
        formTechnicalList,
        formTacticalList,
        formPhysicalList,
        formMentalList,
        formSociMalList,
      } = this.fiveRings;
      const tem_technical = this.parseFormData(formTechnicalList);
      const tem_tactical = this.parseFormData(formTacticalList);
      const tem_physical = this.parseFormData(formPhysicalList);
      const tem_mental = this.parseFormData(formMentalList);
      const tem_social = this.parseFormData(formSociMalList);
      const submitData = {
        id: this.reportId,
        scoreList: JSON.stringify([
          ...tem_technical,
          ...tem_tactical,
          ...tem_physical,
          ...tem_mental,
          ...tem_social,
        ]),
      };
      postFiveRingsReport(submitData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          let routeQuery = {
            scoutId: this.scoutId,
            reportId: this.reportId,
          };
          if (this.isEdit) {
            routeQuery["isEdit"] = 1;
          }
          this.$router.push({
            path: "list",
            query: routeQuery,
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    /* 解析表单内容，数据扁平化 */
    parseFormData(list) {
      let newList = [];
      if (list && list.length) {
        newList = list.map((item) => ({
          report_id: item.report_id,
          indicator_id: item.indicator_id,
          player_id: item.player_id,
          score: item.score,
        }));
      } else {
        console.warn("五环指标评价项解析错误");
      }
      return newList;
    },

    // 加载五环评分指标项
    loadIndicators() {
      getFiveRingsInfo()
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }

          let technicalList = [];
          let tacticalList = [];
          let physicalList = [];
          let mentalList = [];
          let socialList = [];
          let otherList = []; // 冗余信息
          data.result.forEach((item) => {
            if (item.indicator_type === "technical") {
              technicalList.push(item);
            }
            if (item.indicator_type === "tactical") {
              tacticalList.push(item);
            }
            if (item.indicator_type === "physical") {
              physicalList.push(item);
            }
            if (item.indicator_type === "mental") {
              mentalList.push(item);
            }
            if (item.indicator_type === "social") {
              socialList.push(item);
            }
            if (
              item.indicator_type !== "technical" ||
              item.indicator_type !== "tactical" ||
              item.indicator_type !== "physical" ||
              item.indicator_type !== "mental" ||
              item.indicator_type !== "social"
            ) {
              otherList.push(item);
            }
          });

          this.technicalList = technicalList;
          this.tacticalList = tacticalList;
          this.physicalList = physicalList;
          this.mentalList = mentalList;
          this.socialList = socialList;

          this.formateDataTodealForm();
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    /* 表单数据构造 */
    formateDataTodealForm() {
      const playerUuid = this.playerId;
      const reportid = this.reportId;
      let formTechnicalList = this.technicalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.id,
        indicatorUuid: item.uuid,
      }));

      let formTacticalList = this.tacticalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.id,
        indicatorUuid: item.uuid,
      }));

      let formPhysicalList = this.physicalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.id,
        indicatorUuid: item.uuid,
      }));

      let formMentalList = this.mentalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.id,
        indicatorUuid: item.uuid,
      }));

      let formSociMalList = this.socialList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.id,
        indicatorUuid: item.uuid,
      }));

      this.fiveRings = Object.assign({}, this.fiveRings, {
        formTechnicalList,
        formTacticalList,
        formPhysicalList,
        formMentalList,
        formSociMalList,
      });
    },

    /* 表单成绩格式化 */
    formateDataTodealFormWithScore() {
      const playerUuid = this.playerId;
      const reportid = this.reportId;
      let formTechnicalList = this.technicalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.indicator_id,
        indicatorUuid: item.uuid,
      }));

      let formTacticalList = this.tacticalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.indicator_id,
        indicatorUuid: item.uuid,
      }));

      let formPhysicalList = this.physicalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.indicator_id,
        indicatorUuid: item.uuid,
      }));

      let formMentalList = this.mentalList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.indicator_id,
        indicatorUuid: item.uuid,
      }));

      let formSociMalList = this.socialList.map((item) => ({
        score: item.score ? Number(item.score) : 0,
        indicator_name: item.indicator_name,
        indicator_paraphrase: item.indicator_paraphrase,
        player_id: playerUuid,
        report_id: reportid,
        indicator_id: item.indicator_id,
        indicatorUuid: item.uuid,
      }));

      this.fiveRings = Object.assign({}, this.fiveRings, {
        formTechnicalList,
        formTacticalList,
        formPhysicalList,
        formMentalList,
        formSociMalList,
      });
    },

    // 编辑模式
    loadEditFiveRingsInfo() {
      const paramsData = {
        id: this.reportId,
      };
      getReportIndicatorsInfo(paramsData).then(({ data }) => {
        if (data.status !== 0) {
          this.$message.error(data.msg);
          return;
        }
        if (!data.result.length) {
          this.loadIndicators();
        } else {
          let technicalList = [];
          let tacticalList = [];
          let physicalList = [];
          let mentalList = [];
          let socialList = [];
          let otherList = []; // 冗余信息
          data.result.forEach((item) => {
            if (item.indicator_type === "technical") {
              technicalList.push(item);
            }
            if (item.indicator_type === "tactical") {
              tacticalList.push(item);
            }
            if (item.indicator_type === "physical") {
              physicalList.push(item);
            }
            if (item.indicator_type === "mental") {
              mentalList.push(item);
            }
            if (item.indicator_type === "social") {
              socialList.push(item);
            }
            if (
              item.indicator_type !== "technical" ||
              item.indicator_type !== "tactical" ||
              item.indicator_type !== "physical" ||
              item.indicator_type !== "mental" ||
              item.indicator_type !== "social"
            ) {
              otherList.push(item);
            }
          });

          this.technicalList = technicalList;
          this.tacticalList = tacticalList;
          this.physicalList = physicalList;
          this.mentalList = mentalList;
          this.socialList = socialList;

          this.formateDataTodealFormWithScore();
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.score-nav
  font-size $font_size_big
  display flex
  align-items center
  line-height $font_size_big
  color $color_white
.page-main
  width 100%
  padding 10px 10px 15px 25px
  box-sizing border-box
  background-color $block_bg_color_base
.scroll-area
  height 500px
  margin-bottom 15px
  .fiveRings-dom
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding-top 20px
    // height 400px
    box-sizing border-box
  .yioks-fiveRings-item
    margin-right 180px
  .yioks-input
    width 300px
.btn-box
  width 100%
  display flex
  justify-content center
  align-items center
.mr-25
  margin-right 25px

.score-tips
  margin-left 10px
  color $color_warn


.suc
  color $color_suc
.err
  color $color_err
.warn 
  color $color_warn
.default
  color $color_white
</style>

<style lang="stylus">
.step-box
  display flex
  width 100%
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
    width 100%
    padding 13px 4%
.fiveRings-dom
  .el-form-item__label
    color #fff !important
    font-size 16px
</style>

<style scoped lang="stylus">
.form-content
  margin-right 25px
  span.thead
    height 40px
    font-size 18px
    font-weight 600
    line-height 40px
    text-align center
  .label-wrapper, .conten-wrapper
    width 100%
.tr
  display flex
  width 100%
  border 1px solid #fff
  border-bottom none
  &:last-child
    border-bottom 1px solid #fff
.td
  border-right 1px solid #fff
  width 100%
  &:last-child
    border-right none
.sub-tr
  display flex
  width 100%
  border-bottom 1px dashed #fff
  height 32px
  line-height 32px
  &:last-child
    border-bottom none
.sub-td
  width 100%
  border-right 1px dashed #fff
  display flex
  justify-content flex-start
  align-items center
  margin-left 25px
  &:last-child
    border-right none
.content-text
  text-indent 2em
  height 24px
  line-height 24px
.w240
  width 240px
.w500
  width 500px
.content-center
  display flex
  align-items center
  justify-content center
</style>

<style lang="stylus">
.scout-rate
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
  .el-form-item__label
    color #fff
    font-size 16px
  .el-rate__text
    color #fff !important
</style>